import React, { useState, useEffect, useContext } from 'react';
import { CChartDoughnut } from '@coreui/react-chartjs';
import {
  CButton,
  CButtonGroup,
  CButtonToolbar,
  CCard,
  CCardBody,
  CCardTitle,
  CCol,
  CRow,
} from '@coreui/react';
import { getDatabase, ref, onValue } from 'firebase/database';
import MoodInput from './MoodInput';
import { FirebaseContext } from '../../firebase';
import { getStyle, hexToRgba } from '@coreui/utils';

const brandPrimary = '#0080FF';
const brandSuccess = '#00FF80';
const brandInfo = '#FF8000';
const brandWarning = '#FF0000';
const brandDanger = '#800080';

const MoodRing = () => {
  const [moodData, setMoodData] = useState([]);
  const [date, setDate] = useState(new Date().toISOString());
  const [radioSelected, setRadioSelected] = useState(1);
  const firebase = useContext(FirebaseContext);

  // Function to fetch mood data from Firebase
  const fetchMoodData = () => {
    const db = getDatabase(); // Initialize real-time database
    const moodRef = ref(db, `moodObservations/${firebase.auth.currentUser.uid}`); // Reference to moodObservations based on the user's UID

    // Real-time listener for updates to moodData
    onValue(moodRef, (snapshot) => {
      const data = snapshot.val();
      const formattedMoodData = data
        ? Object.keys(data).map((key) => ({
          ...data[key],
          uid: key,
        }))
        : [];
      setMoodData(formattedMoodData); // Continuously update the mood data
    });
  };

  useEffect(() => {
    fetchMoodData(); // Fetch mood data on mount
  }, []); // Empty dependency array ensures it runs only once when the component mounts

  const labels = moodData.map((data) => data.effectiveDateTime.split('T')[0] || 'No Date');
  const moodValues = moodData.map((data) => {
    switch (data.display) {
      case 'Happy': return 70;
      case 'Sad': return 30;
      case 'Angry': return 40;
      case 'Calm': return 80;
      case 'Anxious': return 20;
      default: return 50;
    }
  });

  const mainChart = {
    labels: labels,
    datasets: [
      {
        label: 'Mood',
        backgroundColor: [
          hexToRgba(brandInfo, 10),
          hexToRgba(brandSuccess, 10),
          hexToRgba(brandWarning, 10),
          hexToRgba(brandDanger, 10),
          hexToRgba(brandPrimary, 10),
        ],
        borderColor: [
          brandInfo,
          brandSuccess,
          brandWarning,
          brandDanger,
          brandPrimary,
        ],
        borderWidth: 2,
        data: moodValues,
      },
    ],
  };

  const mainChartOpts = {
    tooltips: {
      enabled: true,
      intersect: true,
      mode: 'index',
      position: 'nearest',
      callbacks: {
        labelColor: function (tooltipItem, chart) {
          return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor };
        },
      },
    },
    maintainAspectRatio: false,
    legend: {
      display: true,
    },
  };

  const onRadioBtnClick = (selected) => {
    setRadioSelected(selected);
  };

  return (
    <div>
      <MoodInput fetchLatestMoodData={fetchMoodData} /> {/* Pass the fetch function to MoodInput */}
      <CRow>
        <CCol>
          <CCard>
            <CCardBody>
              <CRow>
                <CCol sm="5">
                  <CCardTitle className="mb-0">Mood Ring</CCardTitle>
                  <div className="small mb-2">Last refreshed: {date}</div>
                </CCol>
                <CCol sm="7" className="d-none d-sm-inline-block">
                  <CButton color="primary" className="float-right">
                    <i className="icon-cloud-download"></i>
                  </CButton>
                  <CButtonToolbar className="float-right" aria-label="Toolbar with button groups">
                    <CButtonGroup className="mr-3" aria-label="First group">
                      <CButton color="outline-secondary" onClick={() => onRadioBtnClick(1)} active={radioSelected === 1}>Day</CButton>
                      <CButton color="outline-secondary" onClick={() => onRadioBtnClick(2)} active={radioSelected === 2}>Month</CButton>
                      <CButton color="outline-secondary" onClick={() => onRadioBtnClick(3)} active={radioSelected === 3}>Year</CButton>
                    </CButtonGroup>
                  </CButtonToolbar>
                </CCol>
              </CRow>
              <div className="chart-wrapper" style={{ height: '300px', marginTop: '40px' }}>
                <CChartDoughnut data={mainChart} options={mainChartOpts} height={300} />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
};

export default MoodRing;


